import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';

import MyModal from '../../components/Modal/Modal';
import { addLanguage, updateLanguage } from '../../api/languages';

const NewLanguageModal = ({
  mode = "create",
  open = false,
  languageData,
  refreshList = () => {},
  onClose = () => {},
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);
  const [modalMode, setModalMode] = useState(false);
	// processing is for user initiated component api calls
	const [processing, setProcessing] = useState(false);
  const [languageInfo, setLanguageInfo] = useState(null);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");


  useEffect(() => setModalMode(mode), [mode]);
  useEffect(() => {
    if(languageData){
      setLanguageInfo(languageData);
      setName(languageData?.name);
      setUrl(languageData?.url);
    }
    else{
      setName("");
      setUrl("");
    }
  }, [languageData]);
  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const onChangeName = (input) => {
    setName(input);
  };

  const onChangeUrl = (input) => {
    setUrl(input);
  };

  const saveLanguage = (e) => {
    e.preventDefault();
    
    if (!name) {
      toaster("Please enter name", "warning")
      return;
    }
    
    setProcessing(true);
    if(modalMode === "create"){
      addLanguage(name).then(res => {
        toaster("Created new language", "success")
        setName("");
        setUrl("")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to create new Language", "error")
        setProcessing(false);
      });
    } else{
      updateLanguage(languageInfo.id, {name:name}).then(res =>{
        toaster("Language updated successfully", "success")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to update global language", "error")
        setProcessing(false);
      });;
    };
  }

  
	const additionalProps = {
		className: 'some-class',
		onSubmit: saveLanguage
	};
  
  return (
    <MyModal
      modalHeading="Language Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ModalContent>

      {
					processing || loading ? 
					<Loading/> 
					:
					<></>
				}
				
				<Form {...additionalProps}>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              value={name}
              labelText="Language Name*"
              // placeholder="Please enter Language Name"
              onChange={e => onChangeName(e.target.value)}
              required
            />
          </div>


          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => onCreate()}
              style={addBtnStyle}  
            >{ (modalMode === "create") ? "Create Language" : "Update Language" }</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default NewLanguageModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
